import React, { useState, useEffect, useContext } from "react"
import { createContext } from "react"
import { GeneralContext } from "./GeneralContext"
import { usePreguntas } from "../hooks/usePreguntas.js"
import { useUser } from "../hooks/useUser.jsx"
import { useContestaciones } from "../hooks/useContestaciones.jsx"
import { useCuestionario } from "../hooks/useCuestionario.js"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"


export const CuestionContext = createContext();

export function CuestionContextProvider(props) {
    const { idCuestionarioActual, setCuestionarioID, idAxe, setQuestionaryPercentage } = useContext(GeneralContext);
    const { getPreguntaActual } = usePreguntas();
    const [cuestion, setCuestion] = useState();
    const { user } = useUser();
    const { setGuardarContestacion, getPreguntaAnterior } = useContestaciones();
    const { anularEje } = useCuestionario();
    const navigate = useNavigate();
    const [ultimaCuestion, setUltimaCuestion] = useState(null);
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(null);

    useEffect(() => {
        if (user != null) getContestacion();
    }, [user]);

    function getContestacion() {
        getPreguntaActual(user, idAxe).then(
            (preguntaActual) => {
                setCuestionValues(preguntaActual);
                setLoading(null);
            },
            (promiseError) => {
                console.error("Error: " + promiseError);
            }
        );
    }

    function setCuestionValues(cuestion) {
        setCuestion({ ...cuestion });
        setQuestionaryPercentage(cuestion.porcentajeTotal);
    }

    function PreguntaAnterior(preguntaActual) {
        var preguntaActual = getPreguntaAnterior(
            user,
            !preguntaActual ? 0 : preguntaActual.id_pregunta,
            idAxe
        );
        preguntaActual.then(
            (promiseFullfilled) => {
                setCuestionValues(promiseFullfilled);
                setLoading(null);
            },
            (promiseError) => {
                console.error("Error: " + promiseError);
            }
        );
    }

    function PreguntaRespondida(preguntaRespuesta) {
        if (preguntaRespuesta && preguntaRespuesta.length > 0 && preguntaRespuesta[0]) {
            var nuevaContestacion = {
                id_cuestionario: idCuestionarioActual,
                id_pregunta: preguntaRespuesta[0].id_pregunta,
                id_respuestas: preguntaRespuesta.map(p => p.id_respuesta),
                id_eje: cuestion.pregunta.eje.id_eje,
                id_usuario: user.id,
                token: user.token,
                language: user.language,
            }
            var contestacionGuardada = setGuardarContestacion(nuevaContestacion);
            contestacionGuardada.then(
                (promiseFullfilled) => {
                    setCuestionarioID(promiseFullfilled.idCuestionario);
                    setCuestionValues(promiseFullfilled);
                    setRespuestaSeleccionada(null);
                    setUltimaCuestion(promiseFullfilled.ultimaCuestion)
                    setLoading(null);
                },
                (promiseError) => {
                    console.error("Error: " + promiseError);
                }
            );
        }
    }

    const [RespuestaSeleccionada, setRespuestaSeleccionada] = useState(null);

    function volverMisCuestionarios() {
        navigate("/MisCuestionarios")
    }

    const backToAxes = () => {
        navigate("/Ejes")
    }

    return (
        <CuestionContext.Provider
            value={{
                cuestion,
                getPreguntaActual,
                user,
                navigate,
                setCuestion,
                getPreguntaAnterior,
                setGuardarContestacion,
                PreguntaRespondida,
                PreguntaAnterior,
                RespuestaSeleccionada,
                setRespuestaSeleccionada,
                volverMisCuestionarios,
                backToAxes,
                t,
                ultimaCuestion,
                setUltimaCuestion,
                setCuestionValues,
                anularEje,
                setLoading
            }}
        >
            {props.children}
        </CuestionContext.Provider>
    );
}
